'use client';

import React from 'react';
import { cn } from '@/lib/utils';
import ResponsiveWrapper from '@/components/layout/ResponsiveWrapper';
import type { DividerProps } from './types';

function Divider({
  color = 'border-border',
  thickness = 'border-t',
  margin = 'my-4',
  orientation = 'horizontal',
  responsive = {},
  className = '',
  ...props
}: DividerProps) {
  const classes = cn(
    'w-full',
    orientation === 'vertical' && 'h-full w-auto border-l',
    color,
    thickness,
    margin,
    className,
  );

  return (
    <ResponsiveWrapper responsive={responsive}>
      <hr className={classes} {...props} />
    </ResponsiveWrapper>
  );
}

export default React.memo(Divider);
